"use strict";
function google_search (event) {
    if (event.preventDefault) { event.preventDefault(); }
    window.location.href = "https://www.google.com/search?q=site%3A" + encodeURIComponent(__app.site.short_url)
        + "&q=" + encodeURIComponent(document.getElementById("nav-search-text").value);
}
document.getElementById("nav-search-button").onclick = function (event) {
    google_search(event);
};
let searchForm = document.getElementsByName('nav-search')[0];
if (searchForm.addEventListener) {
    searchForm.addEventListener("submit", google_search, false);
}



// WEBPACK FOOTER //
// ./src/_assets/js/google_search.js